import * as React from 'react';
import DiilHeaderInner from './DiilHeaderInner';
const DiilHeader = (props) => {
    var _a;
    const [path, setPath] = React.useState((_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname);
    const navigateFn = (event) => {
        (props === null || props === void 0 ? void 0 : props.navigate) && props.navigate(event);
        const pathName = event.currentTarget.pathname;
        setPath(pathName);
    };
    const translateFn = (key) => {
        var _a;
        return (_a = props.diilGlobalTranslations) === null || _a === void 0 ? void 0 : _a[key];
    };
    return (React.createElement(DiilHeaderContext.Provider, { value: { ...props, translate: translateFn, location: path, navigate: navigateFn } },
        React.createElement(DiilHeaderInner, null)));
};
export default DiilHeader;
export const DiilHeaderContext = React.createContext(null);
//# sourceMappingURL=DiilHeader.js.map